<template>
<div class="chapter">
<div class="inner_page">
<div>
<p class="ORIM-Dedication" style="margin-top:3em;">In memory of our precious Siamese cat, Trey</p>
<p class="ORIM-Dedication">For being company when I was lonely. For giving sympathy when I was sad or sick. For Indian dances in the morning and for cuddling on chilly nights. For bug-busting, wigginess, and safety. For the imagination you fueled. For simply being you, a gentle presence in our lives. We love and miss you.</p>
<p class="ORIM-Dedication">and</p>
<p class="ORIM-Dedication">For little one-eyed Oscar</p>
<p class="ORIM-Dedication">Because you made me smile, and I cared.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Untitled11.vue?02e0f811